const styles = (theme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      backgroundColor: "rgba(255, 255, 255, 0.15)",
      backdropFilter: "blur(12px)",
      WebkitBackdropFilter: "blur(12px)",
      border: "1px solid rgba(255, 255, 255, 0.2)",
      borderRadius: "16px",
      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
    },
    "& .MuiBackdrop-root": {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
    },
  },
  dialogContent: {
    padding: theme.spacing(4),
    "&:first-child": {
      paddingTop: theme.spacing(4),
    },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minWidth: 200,
    minHeight: 200,
  },
  lottieContainer: {
    width: "100%",
    maxWidth: 150,
    height: "auto",
  },
});

export default styles;
